module.exports = __webpack_public_path__ + "img/img-related06.158c5e72.jpg";